import type { ApiRoute, NoBody, NoPathParams } from "../../api"
import type { PriceTagView } from "./PriceTagView"

export interface PriceTagQueryParams {
	"inventory-id": string
}

export const getPriceTagViewRoute: ApiRoute<NoPathParams, PriceTagQueryParams, NoBody, PriceTagView> = {
	buildUrl: () => "/price-tag",
	method: "get",
	path: "/price-tag",
}
